

import { titleize } from 'inflected';
import { MergeSchemaData } from '../model/merge.schema.data';
import { getMergeSchema } from '../utilities/get.merge.schema';
import { MergeCatalog } from '../merge.catalog';

export const MergeSchema = (options?: Partial<MergeSchemaData>): ClassDecorator => {
    return (target: Function) => {
        const meta = getMergeSchema(target.prototype);
        meta.entity = options?.entity;
        meta.name = options?.name;

        MergeCatalog.registerMergeSchema(meta);
        // meta.displayName = titleize(target.prototype.name)

        // const schema = {
        //     name: target.prototype.name,
        //     displayName: titleize(target.prototype.name),
        // } as MergeSchemaData;


    };
};